import apiHeader from '@/helpers/apiHeader';

const priorityTypeService = {
  list(page, params) {
    return apiHeader.get('priority-types?page=' + page, { params });
  },
  get(id) {
    return apiHeader.get('priority-types/' + id);
  },
};

export default priorityTypeService;
